"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./CheckboxInput.scss");
var CheckboxInput = function CheckboxInput(_ref) {
  var isChecked = _ref.isChecked,
    isDisabled = _ref.isDisabled,
    onChange = _ref.onChange,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("input", {
    checked: isChecked,
    disabled: isDisabled,
    onChange: onChange,
    type: "checkbox",
    className: (0, _classnames["default"])(className, 'cds-CheckboxInput')
  });
};
exports.CheckboxInput = CheckboxInput;